// eslint-disable-next-line no-unused-vars
import { DefaultTheme } from 'styled-components'
const baseSizeRaw = 9

const theme: DefaultTheme = {
  sizes: {
    baseSizeRaw: baseSizeRaw,
    baseSize: `${baseSizeRaw}px`,
    minAppWidth: '320px',
    contentMaxWidth: '1000px',
    navbarHeight: '50px',
    collectionsNavHeight: '40px',

    gutterSmallest: `${baseSizeRaw / 3}px`,
    gutterSmaller: `${baseSizeRaw / 2}px`,
    gutterSmall: `${baseSizeRaw}px`,
    gutterMedium: `${baseSizeRaw * 2}px`,
    gutterLarge: `${baseSizeRaw * 3}px`,
    gutterLarger: `${baseSizeRaw * 4}px`,
    gutterLargest: `${baseSizeRaw * 8}px`,
    gutterDefault: `${baseSizeRaw * 2}px`,
  },
  fontSizes: {
    fontSizeSmallest: '1.1rem',
    fontSizeSmaller: '1.2rem',
    fontSizeSmall: '1.5rem',
    fontSizeNormal: '1.8rem',
    fontSizeLarge: '2.1rem',
    fontSizeLarger: '2.3rem',
    fontSizeLargest: '2.7rem',
    fontSizeHuge: '3.6rem',
    titleFontSize: '3.6rem',
    presslyFontFamily: "Roboto, 'Helvetica Neue', sans-serif",
  },
  colors: {
    grayLightest: '#fafafa',
    grayLighter: '#eee',
    grayLight: '#ccc',
    grayMedium: '#8893A0',
    grayDark: '#697E8E',
    grayDarker: '#3C4D5D',
    grayDarkest: '#212A33',

    infoBlueBorder: '#5066E1',
    infoBlueLight: '#DFECFE',
    blueLight: '#667dac',
    blueDark: '#002775',

    primaryAccentColor: '#0C8EF0',
    secondaryAccentColor: '#697e8e',
    dangerAccentColor: '#FF756E',
    primaryHeadlineColor: '#212932',
    secondaryHeadlineColor: '#363635',
    detailColor: '#535A63',
    bylineColor: '#697E8E',
    bodyColor: '#363E45',
    bodyColorLight: '#9E9E9E',
    iconColor: 'rgb(186, 194, 205)',
    tagColor: '#697E8E',
    newsletterBlockHover: '#F8F8F8',

    newsletterIconBackgroundColor: '#3F464A',
    matteColor: 'rgb(253, 253, 253)',
    slabBorderColor: 'rgb(240, 240, 240)',
    slabDarkBorderColor: '#D8D8D8',
    newsletterSlabcover: '#f4f6f8',
    newsletterIconHoverColor: '#0D8EEE',

    contentShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.06)',
    contentShadowHover: '0px 2px 6px 0px rgba(0,0,0,0.07)',

    placeholderColor: '#e6edf1',

    // Social networks
    email: '#ff5c58',
    twitter: '#4099ff',
    linkedin: '#007bb6',
    facebook: '#3b5998',
    gplus: '#dd5044',
    rss: '#dd5044',
    soundcloud: '#ff6600',
    youtube: '#e52d27',
    vimeo: '#162221',
    instagram: '#517fa4',
    pinterest: '#cb2027',
    slack: '#444444',
    pressly: '#000',

    // Checkbox
    inactiveBorderColor: '#dbdfe2',
    inactiveBackgroundColor: '#f9f9f9',

    dangerColor: 'rgb(254, 106, 102)',
    successColor: '#25CE8B',
    warningColor: 'orange',
    normalColor: 'rgb(181, 187, 199)',

    successBgColor: '#84EDC4',
    dangerBgColor: '#F8A39E',
    warningBgColor: '#F4CA84',

    accessibilityOutlineColor: '#afafaf',
  },
}

export { theme }
